import React from "react";
import { Heart, BookOpen, Users, ExternalLink } from "lucide-react";

const PILLARS = [
  { icon: BookOpen, title: "Educate", body: "Workshops and awareness drives across schools and youth centers on infectious disease prevention." },
  { icon: Heart, title: "Empower", body: "Mentorship and health literacy programs that equip young people to advocate within their own communities." },
  { icon: Users, title: "Equip", body: "Resources, screenings, and partnerships with local clinics to make care accessible." },
];

export default function Community() {
  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid="community-page">
      <section className="relative h-[70vh] flex items-end">
        <img src="https://images.pexels.com/photos/14500291/pexels-photo-14500291.jpeg" alt="YAAIDFI" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" />
        <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 pb-16 w-full">
          <p className="overline mb-4">In Partnership With</p>
          <h1 className="font-display text-5xl md:text-7xl font-light text-white tracking-tighter leading-[0.95]">
            YAAIDFI <span style={{color:"var(--davide-red)"}}>Foundation</span>
          </h1>
          <p className="text-white/80 mt-6 max-w-2xl text-lg">
            Youth Awareness for Infectious Diseases Foundation International — educating, empowering, and equipping a generation.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24">
        <div className="grid md:grid-cols-3 gap-10">
          {PILLARS.map((p) => (
            <div key={p.title} className="border border-white/10 p-10 bg-[#101010] hover:border-[var(--davide-gold)] transition-colors" data-testid={`pillar-${p.title.toLowerCase()}`}>
              <p.icon size={28} className="text-[var(--davide-gold)] mb-6" />
              <h3 className="font-display text-3xl text-white mb-4">{p.title}</h3>
              <p className="text-white/70 leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#0E0E0E] py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
          <p className="overline mb-4">Every Purchase Counts</p>
          <h2 className="font-display text-4xl md:text-5xl font-light text-white leading-tight">
            A portion of every DaviDÉ sale funds YAAIDFI's outreach.
          </h2>
          <p className="text-white/70 mt-6 text-lg">
            When you wear DaviDÉ, you wear a story — and you become part of the next chapter. Thank you for standing with us.
          </p>
          <a href="https://www.yaaidfi.org" target="_blank" rel="noopener noreferrer"
            data-testid="visit-yaaidfi-btn"
            className="btn-gold inline-flex mt-10">
            Visit YAAIDFI.org <ExternalLink size={16}/>
          </a>
        </div>
      </section>
    </div>
  );
}
